import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Information16 from '@carbon/icons-react/es/information/16';
import { Space, Tooltip } from 'antd';
import styled from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';
const InfoIcon = styled(Information16)`
  color: var(--gray-40);
`;
const IconWrapper = styled.span`
  display: flex;
`;
const Title = styled.span`
  ${SingleLineEllipsis};
  * {
    ${SingleLineEllipsis};
  }
`;
const Wrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: ${({ align })=>align === 'right' ? 'flex-end' : align === 'center' ? 'center' : 'flex-start'};
  gap: 4px;

  ${IconWrapper} {
    flex-shrink: 0;
  }
  ${InfoIcon} {
    flex-shrink: 0;
  }
`;
const TooltipForHeader = ({ title, description })=>/*#__PURE__*/ _jsxs(Space, {
        direction: "vertical",
        children: [
            /*#__PURE__*/ _jsx("strong", {
                children: title
            }),
            description
        ]
    });
export const COLUMN_HEADER_WIDTH = 125;
export const ColumnHeader = ({ title, description, icon, align = 'left', className, hideTooltip = false })=>hideTooltip ? /*#__PURE__*/ _jsxs(Wrapper, {
        align: align,
        className: className,
        children: [
            icon != null ? /*#__PURE__*/ _jsx(IconWrapper, {
                children: icon
            }) : null,
            /*#__PURE__*/ _jsx(Title, {
                children: title
            }),
            description != null ? /*#__PURE__*/ _jsx(InfoIcon, {}) : null
        ]
    }) : /*#__PURE__*/ _jsx(Tooltip, {
        title: /*#__PURE__*/ _jsx(TooltipForHeader, {
            title: title,
            description: description
        }),
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            align: align,
            className: className,
            children: [
                icon != null ? /*#__PURE__*/ _jsx(IconWrapper, {
                    children: icon
                }) : null,
                /*#__PURE__*/ _jsx(Title, {
                    children: title
                }),
                description != null ? /*#__PURE__*/ _jsx(InfoIcon, {}) : null
            ]
        })
    });
